import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { EngineTranslationService } from '@core/engine-translations/services/translation.service';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { FileParameter } from 'src/core/services/api-clients';
import { IUploadDialogConfig } from 'src/engine-sdk';
import { UploadBlob } from '../store/actions';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
  imports: [MatIcon, MatButton, TranslatePipe],
})
export class UploadDialogComponent {
  private _store = inject(Store);
  data = inject<IUploadDialogConfig>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<UploadDialogComponent>>(MatDialogRef);
  private _translate = inject(EngineTranslationService);

  fileToUpload: FileParameter;
  newBlobId: string = null;
  filename: string;
  title: string = 'Upload file';

  constructor() {
    if (this.data.title) {
      this.title = this.data.title;
    } else {
      this.title = this._translate.translateInstantly('FileForImport.FileForImportLabel');
    }
  }

  onFileSelected(event: Event) {
    let file = (event.target as HTMLInputElement).files[0];
    if (file == undefined || file == null) return;
    this.fileToUpload = { data: file, fileName: file.name };
    if (file.name.length > 30) {
      this.filename = file.name.substring(0, 30) + '...' + file.name.slice(file.name.lastIndexOf('.'));
    } else {
      this.filename = file.name;
    }
  }

  sendFile() {
    if (this.fileToUpload !== undefined) {
      let obj = {
        file: this.fileToUpload,
        name: this.fileToUpload.fileName,
        type: this.data.blobType,
        onSuccess: (newBlobId: string) => {
          if (this.data.onSuccess) {
            this.data.onSuccess(newBlobId, this.fileToUpload);
          }
          this.close();
        },
        onError: () => {
          if (this.data.onError) {
            this.data.onError();
          }
          this.close();
        },
      };

      this._store.dispatch(new UploadBlob(obj));
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
